const MAX_SCENARIO_NAME_LEN = 30
const ALPHANUMERIC_REGEX = /^$|^\w+$/

export const isScenarioNameAlphanumeric = (scenarioName: string) =>
  ALPHANUMERIC_REGEX.test(scenarioName)

export const isScenarioNameTooLong = (scenarioName: string) =>
  scenarioName.length > MAX_SCENARIO_NAME_LEN

export const getScenarioNameErrorMessage = (
  scenarioName: string,
  isScenarioNameEmpty: boolean,
  isUniqueScenario: boolean
): string => {
  if (scenarioName.length > 0) {
    if (isScenarioNameTooLong(scenarioName)) {
      return `Scenario name can not be more than ${MAX_SCENARIO_NAME_LEN} characters`
    } else if (
      !isScenarioNameAlphanumeric(scenarioName) &&
      scenarioName.length > 0
    ) {
      return 'Scenario name can only contain alphanumeric characters and underscore'
    } else if (!isUniqueScenario) {
      return 'This scenario name is already taken.'
    }
  } else if (isScenarioNameEmpty) {
    return 'Please enter scenario name'
  }

  return ''
}

export const getIsScenarioNameValid = (
  scenarioName: string,
  isUniqueScenario: boolean
) =>
  isScenarioNameAlphanumeric(scenarioName) &&
  !isScenarioNameTooLong(scenarioName) &&
  isUniqueScenario
